import { render, staticRenderFns } from "./_bot.vue?vue&type=template&id=03e0a8a3&lang=pug&"
import script from "./_bot.vue?vue&type=script&lang=js&"
export * from "./_bot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports